import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import { useStateContext } from "./contexts/ContextProvider";
import {
  Clients,
  CreateProducts,
  DashboardDailyRoute,
  Drivers,
  Cities,
  Home,
  MakeRoute,
  Order,
  Orders,
  Product,
  Products,
  Sellers,
  NotFoundPage,
  OrderDetails,
  ReportGeneration,
  LoginPage,
  DashboardLayout,
  CheckPrices,
  Reschedule,
  RouteMonitoring,
  Reports,
  Report,
  GeneralConfig,
  FormatSuggestions,
  AccountsRoles,
} from "./pages";

import { PrivateRoute, RequirePermission } from "./components";

import "./App.css";
import customTheme from "./theme";
import locale from "antd/es/locale/es_ES";

import { AuthProvider } from "./contexts/AuthProvider";

const AppContent = () => {
  const { darkMode } = useStateContext();
  return (
    <AuthProvider>
      <ConfigProvider
        theme={{
          ...customTheme(darkMode),
          algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        }}
        locale={locale}
      >
        <Router>
          <Routes>
            {/* Login */}
            <Route path="/login" element={<LoginPage />} />

            {/* Dashboard */}
            <Route
              path="*"
              element={
                <DashboardLayout>
                  <Routes>
                    <Route
                      path="/"
                      element={<PrivateRoute element={<Home />} />}
                    />
                    <Route
                      path="/home"
                      element={<PrivateRoute element={<Home />} />}
                    />
                    <Route
                      path="/orders"
                      element={
                        <RequirePermission
                          permission="orders:read"
                          element={<Orders />}
                        />
                      }
                    />
                    <Route
                      path="/orders/:id"
                      element={
                        <RequirePermission
                          permission="orders:read"
                          element={<OrderDetails />}
                        />
                      }
                    />
                    <Route
                      path="/products"
                      element={
                        <RequirePermission
                          permission="products:read"
                          element={<Products />}
                        />
                      }
                    />
                    <Route
                      path="/products/create"
                      element={
                        <RequirePermission
                          permission="products:create"
                          element={<CreateProducts />}
                        />
                      }
                    />
                    <Route
                      path="/products/:product_id"
                      element={
                        <RequirePermission
                          permission="products:read"
                          element={<Product />}
                        />
                      }
                    />
                    <Route
                      path="/sellers"
                      element={
                        <RequirePermission
                          permission="personnel:read"
                          element={<Sellers />}
                        />
                      }
                    />
                    <Route
                      path="/clients"
                      element={<PrivateRoute element={<Clients />} />}
                    />
                    <Route
                      path="/drivers"
                      element={
                        <RequirePermission
                          permission="personnel:read"
                          element={<Drivers />}
                        />
                      }
                    />
                    <Route
                      path="/cities"
                      element={
                        <RequirePermission
                          permission="cities:read"
                          element={<Cities />}
                        />
                      }
                    />
                    <Route
                      path="/makeroute"
                      element={
                        <RequirePermission
                          permission="orders:write"
                          element={<MakeRoute />}
                        />
                      }
                    />
                    <Route
                      path="/reports"
                      element={
                        <RequirePermission
                          permission="reports:read"
                          element={<Reports />}
                        />
                      }
                    />
                    <Route
                      path="/reports/:report_id"
                      element={
                        <RequirePermission
                          permission="reports:read"
                          element={<Report />}
                        />
                      }
                    />
                    <Route
                      path="/checkprices"
                      element={
                        <RequirePermission
                          permission="orders:write"
                          element={<CheckPrices />}
                        />
                      }
                    />
                    <Route
                      path="/reschedule"
                      element={
                        <RequirePermission
                          permission="orders:write"
                          element={<Reschedule />}
                        />
                      }
                    />
                    <Route
                      path="/dashboardDailyRoute"
                      element={
                        <RequirePermission
                          permission="orders:read"
                          element={<DashboardDailyRoute />}
                        />
                      }
                    />
                    <Route
                      path="/dashboardDailyRoute/:routeDay"
                      element={
                        <RequirePermission
                          permission="orders:read"
                          element={<DashboardDailyRoute />}
                        />
                      }
                    />
                    <Route
                      path="/route-monitoring"
                      element={<PrivateRoute element={<RouteMonitoring />} />}
                    />
                    <Route
                      path="/route-monitoring/:routeDay"
                      element={<PrivateRoute element={<RouteMonitoring />} />}
                    />
                    <Route
                      path="/generalconfig"
                      element={
                        <RequirePermission
                          permission="permissions:write"
                          element={<GeneralConfig />}
                        />
                      }
                    />
                    <Route
                      path="/format-suggestions"
                      element={
                        <RequirePermission
                          permission="orders:read"
                          element={<FormatSuggestions />}
                        />
                      }
                    />
                    <Route
                      path="/accounts"
                      element={
                        <RequirePermission
                          permission="users:write"
                          element={<AccountsRoles />}
                        />
                      }
                    />
                    <Route path="/notFoundPage" element={<NotFoundPage />} />
                  </Routes>
                </DashboardLayout>
              }
            />
          </Routes>
        </Router>
      </ConfigProvider>
    </AuthProvider>
  );
};

const App = () => <AppContent />;

export default App;
